import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as Yup from "yup";
import { Formik } from "formik";
import Dropzone from "../inputs/Dropzone";

const useStyles = makeStyles(() => ({
  styledTextfield: {
    "& .MuiInputBase-root": {
      borderRadius: "12px",
    },
  },
  styledAnchor: {
    borderBottom: "1px solid #B1D238",
  },
  anchorTag: {
    fontWeight: 500,
    borderBottom: "1px solid black",
    color: "black",
  },
}));

const SignupProfessionalForm = () => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const INI_DATA = {
    first_name: "",
    last_name: "",
    password: "",
    cpassword: "",
    imageURL: "",
  };

  const SCHEMA = {
    first_name: Yup.string()
      .required("Field is required")
      .matches(/^[aA-zZ\s]+$/, "Numbers and special character not allowed"),
    last_name: Yup.string()
      .required("Field is required")
      .matches(/^[aA-zZ\s]+$/, "Numbers and special character not allowed"),
    password: Yup.string()
      .required("Field is required")
      .min(8, "Password is too short - must be 8 characters minimum.")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/,
        "Must contain an Uppercase, Lowercase and a Number "
      ),
    cpassword: Yup.string().test(
      "passwords-match",
      "Passwords must match",
      function (value) {
        return this.parent.password === value;
      }
    ),
  };

  return (
    <Stack justifyContent="center" alignItems="center" spacing={5}>
      <Stack alignItems="center" spacing={3}>
        <Typography variant="h1" fontWeight={700}>
          Welcome to your Professional Event Network!
        </Typography>
        <Typography variant="h4" fontWeight={500}>
          Find out “What’s Going On” in the financial services industry right at
          your fingertips - Getting started is easy!
        </Typography>
      </Stack>
      <Formik
        initialValues={INI_DATA}
        validationSchema={Yup.object().shape(SCHEMA)}
        onSubmit={(values) => console.log(values)}
        render={({
          handleChange,
          values,
          touched,
          setFieldValue,
          errors,
          handleSubmit,
        }: any) => (
          <Stack width="50%" spacing={2}>
            <form onSubmit={handleSubmit}>
              <Stack alignItems="center">
                <Dropzone
                  image={values.imageURL}
                  rounded
                  handleDrop={(file) => {
                    setFieldValue("imageURL", URL.createObjectURL(file[0]));
                  }}
                />
              </Stack>
              <Stack
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                mt={2}
              >
                <Stack width="100%" mr={2}>
                  <Typography>First Name</Typography>
                  <TextField
                    className={classes.styledTextfield}
                    placeholder="John"
                    fullWidth
                    style={{ border: 0, padding: 0 }}
                    id="first_name"
                    helperText={
                      touched.first_name && errors !== null
                        ? errors.first_name
                        : ""
                    }
                    error={
                      touched.first_name && errors !== null && errors.first_name
                    }
                    onChange={handleChange}
                    value={values.first_name}
                    variant="outlined"
                  />
                </Stack>
                <Stack width="100%">
                  <Typography>Last Name</Typography>
                  <TextField
                    className={classes.styledTextfield}
                    placeholder="Doe"
                    fullWidth
                    style={{ border: 0, padding: 0 }}
                    id="last_name"
                    helperText={
                      touched.last_name && errors !== null
                        ? errors.last_name
                        : ""
                    }
                    error={
                      touched.last_name && errors !== null && errors.last_name
                    }
                    onChange={handleChange}
                    value={values.last_name}
                    variant="outlined"
                  />
                </Stack>
              </Stack>

              <Stack spacing={0.5} position="relative" mt={1.5}>
                <Typography>Password</Typography>
                <TextField
                  className={classes.styledTextfield}
                  type={showPassword ? "text" : "password"}
                  placeholder="*********"
                  fullWidth
                  id="password"
                  style={{ border: 0, padding: 0 }}
                  helperText={
                    touched.password && errors !== null ? errors.password : ""
                  }
                  error={touched.password && errors !== null && errors.password}
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                          style={{ backgroundColor: "white" }}
                          edge="end"
                        >
                          {showPassword ? (
                            <i className="far fa-eye font-grey" />
                          ) : (
                            <i className="far fa-eye-slash font-grey" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={values.password}
                  variant="outlined"
                />
                8 or more characters, with 1 symbol and 1 number
              </Stack>
              <Stack spacing={0.5} position="relative" mt={1.5}>
                <Typography> Confirm Password</Typography>
                <TextField
                  className={classes.styledTextfield}
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="*********"
                  fullWidth
                  id="cpassword"
                  style={{ border: 0, padding: 0 }}
                  helperText={
                    touched.cpassword && errors !== null ? errors.cpassword : ""
                  }
                  error={
                    touched.cpassword && errors !== null && errors.cpassword
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => {
                            setShowConfirmPassword(!showConfirmPassword);
                          }}
                          style={{ backgroundColor: "white" }}
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <i className="far fa-eye font-grey" />
                          ) : (
                            <i className="far fa-eye-slash font-grey" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onChange={handleChange}
                  value={values.cpassword}
                  variant="outlined"
                />
              </Stack>
              <Stack spacing={0.5} position="relative" mt={1.5}>
                <Typography>
                  By signing up, you agree to{" "}
                  <a href="/#" target="_blank" className={classes.styledAnchor}>
                    Terms of Service
                  </a>
                  ,{" "}
                  <a href="/#" target="_blank" className={classes.styledAnchor}>
                    Privacy Policy
                  </a>
                  , and{" "}
                  <a href="/#" target="_blank" className={classes.styledAnchor}>
                    Cookie Policy
                  </a>
                  .
                </Typography>
              </Stack>
              <Box mt={2}>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  fullWidth
                >
                  Agree & Sign Up
                </Button>
              </Box>
              <Box mt={2} textAlign="center">
                Already have an account?{" "}
                <a className={classes.anchorTag} href="/#" target="_blank">
                  Login
                </a>
              </Box>
              <Box mt={2} textAlign="center">
                Need help?{" "}
                <a className={classes.anchorTag} href="/#" target="_blank">
                  Contact support
                </a>
              </Box>
            </form>
          </Stack>
        )}
      />
    </Stack>
  );
};
export default SignupProfessionalForm;
